import React, { useEffect, useRef, useState } from 'react';
import { TitleSection, TopContentWrapper, Wrapper } from '../shared.styles';
import { getQueueLastWeekDeliverity } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import CustomSkeleton from '@/common/components/CustomSkeleton';
import styled from 'styled-components';
import Input from '@/common/components/Input';
import CustomLine from '@/common/charts/Line';

const ChartWrapper = styled.div`
	display: flex;
	align-items: center;
`;

const ContactWeights = () => {
	const [chartData, setChartData] = useState();

	const timeRangeRef = useRef();

	const {
		options: { queuesOptions },
	} = useCommonDataContext();
	const { makeRequest } = useRequestsContext();

	const handleLoadData = async () => {
		setChartData(() => null);

		const payload = {};
		payload.timeFrom = timeRangeRef.current.value;
		payload.timeTo = 2;

		const response = await makeRequest(
			getQueueLastWeekDeliverity.bind(null, payload),
		);

		if (response.data) {
			setChartData(() => response.data);
		}
	};

	useEffect(() => {
		if (queuesOptions[0]) {
			handleLoadData();
		}
	}, [queuesOptions]);

	return (
		<Wrapper width={800}>
			<TitleSection>
				<TopContentWrapper>
					<i className='fa fa-location-dot' />
					Market contact weights
				</TopContentWrapper>
				<TopContentWrapper>
					<Input
						showLabel={false}
						inputWidth={50}
						value={2}
						inputRef={timeRangeRef}
					/>
					<i
						class='fa-solid fa-arrows-rotate animation-scale'
						style={{ cursor: 'pointer' }}
						onClick={() => handleLoadData()}
					/>
				</TopContentWrapper>
			</TitleSection>
			<ChartWrapper>
				{chartData ? (
					<CustomLine
						data={chartData}
						options={{
							scales: {
								y: {
									type: 'linear',
									display: true,
									position: 'left',
								},
							},
						}}
					/>
				) : (
					<CustomSkeleton width={750} count={16} height={5} />
				)}
			</ChartWrapper>
		</Wrapper>
	);
};

export default ContactWeights;
